import { httpClient } from '@/network/clientController'

/** authenticate the user
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_authentication
*/
export const login = payload => {
	return httpClient({
		method: 'POST',
		url: 'authentication',
		data: payload
	})
}

/** sends the credentials by email to a contract that only went through the silent migration
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_migrationsendCredentials
*/
export const sendMigrationCredentials = payload => {
	return httpClient({
		method: 'POST',
		url: 'migration/sendCredentials',
		data: payload
	})
}

/** authenticate the user
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_authenticationrememberMeLogin
*/
export const loginRememberMe = payload => {
	return httpClient({
		method: 'POST',
		url: 'authentication/rememberMeLogin',
		data: payload
	})
}

/** Invalidates rememberMeToken
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_authenticationinvalidateRememberMeLogin
*/
export const invalidRememberMe = payload => {
	return httpClient({
		method: 'POST',
		url: 'authentication/invalidateRememberMeLogin',
		data: payload
	})
}

/** change current account group selected for session
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_authenticationsetSessionContractAccountGroup
*/
export const setSessionContractAccountGroup = payload => {
	return httpClient({
		method: 'POST',
		url: 'authentication/setSessionContractAccountGroup',
		data: payload.data,
		extraMockIdentifier: payload.accountGroupType
	})
}

/** Dismiss INITIAL ACTION to show confirmation modal on accountGroup pick
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/PUT_internetauthenticationinitialActionaccountGroupdismiss
*/
export const updateAccountGroupInitialAction = payload => {
	return httpClient({
		method: 'PUT',
		url: 'authentication/initialAction/accountGroup/dismiss'
	})
}

/** logout the user
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/DELETE_authentication
*/
export const logout = () => {
	return httpClient({
		method: 'DELETE',
		url: 'authentication'
	})
}

/** extends our session
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_authenticationextend
*/
export const extendSession = payload => {
	return httpClient({
		method: 'POST',
		url: 'authentication/extend',
		data: payload
	})
}

/** Modify current password
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_authenticationmodifyPassword
*/
export const modifyPassword = payload => {
	return httpClient({
		method: 'POST',
		url: 'authentication/modifyPassword',
		data: payload,
		operationTypeId: 9914 /* for mocks handling of tokens */
	})
}

/**********************************************************************
*                                                                     *
*                        BIOMETRIC RELATED                            *
*                                                                     *
***********************************************************************/
/**
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_internetauthenticationenrollBiometricKeyAndLogin
*/
export const biometricLogin = payload => {
	return httpClient({
		method: 'POST',
		url: '/authentication/enrollBiometricKeyAndLogin',
		data: payload
	})
}

/**
@docs
*/
export const getBiometricChallenge = payload => {
	return httpClient({
		method: 'POST',
		url: '/authentication/generateBiometricAuthenticationChallenge',
		data: payload
	})
}

/**
@docs
*/
export const sendLoginBiometricChallenge = payload => {
	return httpClient({
		method: 'POST',
		url: '/authentication/validateBiometricChallengeAndLogin',
		data: payload
	})
}

/**
@docs
*/
export const sendExtensionBiometricChallenge = payload => {
	return httpClient({
		method: 'POST',
		url: '/authentication/validateBiometricChallengeAndExtendSession',
		data: payload
	})
}

/**********************************************************************
*                                                                     *
*                        OUTOFBAND RELATED                            *
*                                                                     *
***********************************************************************/
/**
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_authenticationoutofbandstatus
*/
export const getOutofBandValidationRequestStatus = payload => {
	return httpClient({
		method: 'POST',
		url: '/authentication/outofband/status'
	})
}

/**
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_authenticationoutofbandretry
*/
export const retryOutofbandValidationRequest = payload => {
	return httpClient({
		method: 'POST',
		url: '/authentication/outofband/retry'
	})
}

/**
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_authenticationoutofbandprocess%7BprocessId%7D
*/
export const getOutofbandRequestDetail = payload => {
	return httpClient({
		method: 'GET',
		url: `/authentication/outofband/process/${payload}`
	})
}

/**
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_authenticationoutofbandretry
*/
export const validateRefuseOutofbandValidationRequest = payload => {
	return httpClient({
		method: 'PUT',
		url: '/authentication/outofband/validate',
		data: payload
	})
}
